import { Upload } from 'antd';
import type { UploadFile, UploadProps } from 'antd/es/upload/interface';
import { Col } from '../col';
import { message } from '../message';
import { Row } from '../row';
import { UploadButton } from '../upload';
import { UploadFileList } from './upload-file-list';

// TODO: import from ui
const { Dragger } = Upload;

type P = {
  fileList?: UploadFile[];
  removeUpload: () => void;
  retryUpload: () => void;
  startUpload: ({ file }: { file: File }) => void;
};

const VideoDragger = ({ fileList, removeUpload, retryUpload, startUpload }: P) => {
  const customRequest: UploadProps['customRequest'] = ({ file }) => {
    if (file instanceof File) {
      startUpload({ file });
    } else {
      message.error('Uploaded item is not a File object');
    }
  };

  const uploadProperties = {
    accept: 'video/*',
    customRequest,
    fileList,
    maxCount: 1,
    multiple: false,
    showUploadList: false,
  };

  return (
    <Row>
      <Col span={24}>
        <Dragger {...uploadProperties}>
          <UploadButton type="single" />
        </Dragger>
      </Col>

      <Col span={24}>
        {Array.isArray(uploadProperties.fileList) && uploadProperties.fileList[0] ? (
          <UploadFileList file={uploadProperties.fileList[0]} removeUpload={removeUpload} retryUpload={retryUpload} />
        ) : null}
      </Col>
    </Row>
  );
};

export default VideoDragger;
